<script setup>
const props = defineProps({
  url: {
    type: String,
    required: true,
  }
});

const sendEmail = () => {
  const email = props.url;
  window.location.href = `mailto:${email}`;
};
</script>

<template>
    <button @click="sendEmail" class="rounded-full px-8 py-1.5 overflow-hidden relative group cursor-pointer border border-white font-bold bg-white">
    <span class="absolute w-64 h-0 transition-all duration-300 origin-center rotate-45 -translate-x-20 bg-primaryColor top-1/2 group-hover:h-64 group-hover:-translate-y-32 ease"></span>
    <span class="relative text-[14px] md:text-primary text-primaryColor text-nowrap transition duration-300 group-hover:text-white ease">
       <slot />
    </span>
    </button>
</template>
